import { render, staticRenderFns } from "./bm-quote-main.vue?vue&type=template&id=d95ae55a&"
import script from "./bm-quote-main.vue?vue&type=script&lang=js&"
export * from "./bm-quote-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports